import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { ColumnComponent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';

import { AppTextButtonComponent } from "src/app/components/buttons/app-text-button/app-text-button.component";
import { DialogHeaderComponent } from 'src/app/shared/components/dialog-header/dialog-header.component';
import { Site } from '../../../../../models';
import { AppsService } from '../../../../../services';
import { AppAliasService, BulkSiteUploadShapefileLogicService } from '../../../../../services/logic-services';
import { AppFlatButtonComponent } from '../../../../buttons/app-flat-button/app-flat-button.component';

@Component({
    selector: 'kh-bulk-site-upload-shapefile-duplicate-sites-dialog',
    templateUrl: './bulk-site-upload-shapefile-duplicate-sites-dialog.component.html',
    styleUrls: ['./bulk-site-upload-shapefile-duplicate-sites-dialog.component.scss'],
    imports: [
        AppFlatButtonComponent,
        CdkScrollable,
        ColumnComponent,
        DialogHeaderComponent,
        GridComponent,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        AppTextButtonComponent
    ]
})

export class BulkSitesUploadShapefileDuplicateSitesDialogComponent {

    get sitesAliasLowerCase(): string {
        return this._appAliasService.sitesAliasLowerCase;
    }

    get siteAliasLowerCase(): string {
        return this._appAliasService.siteAliasLowerCase;
    }

    get siteAlias(): string {
        return this._appsService.currentApp.aliases.site.singular;
    }

    get theseVsThis(): string {
        return this.overriddenSites.length > 1 ? 'these' : 'this';
    }

    get siteVsSites(): string {
        return this.overriddenSites.length > 1 ? this.sitesAliasLowerCase : this.siteAliasLowerCase;
    }

    get siteNumberTitle(): string {
        return `${this.siteAlias} number`;
    }

    get overriddenSites(): Site[] {
        return this._bulkSiteUploadShapefileLogicService.model.overrideSitesStep.overriddenSites;
    }

    get dataSource(): GridDataResult {
        return this._bulkSiteUploadShapefileLogicService.model.overrideSitesStep.dataSource;
    }

    constructor(
        private _appAliasService: AppAliasService,
        private _appsService: AppsService,
        private _bulkSiteUploadShapefileLogicService: BulkSiteUploadShapefileLogicService,
        private _dialogRef: MatDialogRef<BulkSitesUploadShapefileDuplicateSitesDialogComponent>,
    ) { }

    closeDialog(): void {
        this._dialogRef.close(false);
    }

    onConfirm(): void {
        this._dialogRef.close(true);
    }
}
